import { ACL_TYPE } from '@openx/types/aclType';
import { UserRole } from '@openx/types/user';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext';
import { isAllowedByCompiledAcl } from '@openx/utils/permission/validators';
import { useMemo } from 'react';

export const useOrganizationPermissions = () => {
  const { useIsAllowed } = usePermissionContext();
  const { accessUser, isAllowed } = useIsAllowed();
  const isOaInternal = useMemo(() => !!accessUser?.roles.includes(UserRole.NETWORK_OA_INTERNAL), [accessUser?.roles]);

  const isInternalUser = useMemo(
    () => isAllowed(isAllowedByCompiledAcl(ACL_TYPE.INTERNAL_FIELD_WRITE)) || isOaInternal,
    [isAllowed, isOaInternal]
  );

  return {
    isInternalUser,
  };
};
